import {Injectable} from '@angular/core';
import {CustomStyleService} from './custom-style.service';
import {AuthenticationService} from './authentication.service';
import {NavigationEnd, Router} from '@angular/router';
import {debounceTime, filter} from 'rxjs/operators';

declare const document: any;
declare const window: any;

const ZENDESC_SRC = 'https://static.zdassets.com/ekr/snippet.js?key=ebe7ef87-059c-4995-a8d3-018d678525c4';

@Injectable()
export class ZendescService {

    constructor(
        private cs: CustomStyleService,
        private router: Router,
        private authentication: AuthenticationService,
    ) {
        cs.onThemeChanged.subscribe(theme => {
            this.updateButtonStyle(theme);
        });

        router.events
            .pipe(
                debounceTime(500),
                filter(event => event instanceof NavigationEnd)
            )
            .subscribe(navEnd => {
                this.toggleButtonByUserType();
            });
    }

    initScript(): void {
        const s = document.createElement('script');
        s.async = true;
        s.type = 'text/javascript';
        s.id = 'ze-snippet';
        s.src = ZENDESC_SRC;
        s.onload = (function () {
            window.zE('webWidget', 'hide');
            window.zESettings = {
                position: { vertical: 'top' }
            };
        });
        document.head.appendChild(s);
    }

    showButton(): void {
        if (this.checkInitScript()) {
            window.zE('webWidget', 'show');
        }
    }

    hideButton(): void {
        if (this.checkInitScript()) {
            window.zE('webWidget', 'hide');
        }
    }

    updateButtonStyle(obj): void {
        if (this.checkInitScript()) {
            window.zE('webWidget', 'updateSettings', {
                color: {
                    // theme: this.obj.colors.primary,
                    launcher: obj.colors.primary,
                    // launcherText: this.obj.colors.body,
                    button: obj.colors.primary,
                    // resultLists: this.obj.colors.primary,
                    header: obj.colors.primary,
                    articleLinks: obj.colors.primary
                }
            });
        }
    }

    checkInitScript(): boolean {
        return window.hasOwnProperty('zE') && typeof window['zE'] === 'function';
    }

    private toggleButtonByUserType(): void {
        if (!this.authentication.isAuthorized() || this.authentication.userIsResident) {
            this.hideButton();
        } else {
            this.showButton();
        }
    }
}



// WEBPACK FOOTER //
// /app/src/app/services/zendesc.service.ts